window.CodeHelper = {
    regex: /^[A-Z0-9]{2,10}$/,
    generate: function () {
        const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const a = letters[Math.floor(Math.random() * 26)];
        const b = letters[Math.floor(Math.random() * 26)];
        const n = Math.floor(Math.random() * 100);
        return a + b + String(n).padStart(2, '0');
    },
    fillInput: function (selectorOrElement) {
        const el = typeof selectorOrElement === 'string'
            ? document.querySelector(selectorOrElement)
            : selectorOrElement;
        if (el) {
            el.value = this.generate();
        }
    },
    isValid: function (value) {
        if (!value || typeof value !== 'string') return false;
        return this.regex.test(value.trim().toUpperCase());
    }
};

window.PhoneHelper = {
    regex: {
        '+1': /^\d{10}$/,
        '+44': /^(7\d{9}|1[1-9]\d{8,9}|2\d{9,10}|3\d{9}|5\d{9}|8\d{8,10}|9\d{9})$/,
        '+82': /^1\d{8,10}$/,
        '+225': /^\d{10}$/,
        '+233': /^\d{9}$/,
        '+234': /^\d{10}$/,
        '+243': /^\d{9}$/,
        '+250': /^\d{9}$/,
        '+254': /^\d{9}$/,
        '+255': /^\d{9}$/,
        '+256': /^\d{9}$/,
        '+257': /^\d{8}$/
    },
    isValid: function (dialCode, number) {
        if (!number) return false;

        const normalised = number.replace(/[^\d]/g, '');

        const pattern = this.regex[dialCode];
        if (!pattern) {
            return /^\d{6,15}$/.test(normalised);
        }

        return pattern.test(normalised);
    }
};

window.UsernameHelper = {
    regex: /^(?=.{3,32}$)(?!.*[_.]{2})[a-zA-Z0-9](?:[a-zA-Z0-9._]*[a-zA-Z0-9])$/,
    isValid(username) {
        if (!username) return false;
        username = username.trim();
        return this.regex.test(username);
    }
};

window.NameHelper = {
    regex: /^[A-Za-z][A-Za-z\s'-]{1,49}$/,
    isValid(name) {
        if (!name) return false;
        return this.regex.test(name.trim());
    },
    toTitle: function (value) {
        if (!value || typeof value !== 'string') return '';
        return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
};

window.OTPHelper = {
    initOtpFields(selector) {
        const fields = Array.from(document.querySelectorAll(selector));
        if (fields.length === 0) return;

        fields.forEach((field, index) => {
            field.addEventListener('keypress', (e) => {
                if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                }
            });

            field.addEventListener('input', () => {
                let value = field.value.replace(/\D/g, '');

                if (value.length > 1) {
                    const chars = value.split('');
                    fields[index].value = chars[0] || '';

                    let nextPos = index + 1;

                    for (let i = 1; i < chars.length && nextPos < fields.length; i++, nextPos++) {
                        fields[nextPos].value = chars[i];
                    }

                    const firstEmpty = fields.find(f => f.value === '');
                    (firstEmpty || fields.at(-1)).focus();
                    return;
                }

                field.value = value;

                if (value && index < fields.length - 1) {
                    fields[index + 1].focus();
                }
            });

            field.addEventListener('keydown', (e) => {
                if (e.key === 'Backspace' && !field.value && index > 0) {
                    fields[index - 1].focus();
                }
            });

            field.addEventListener('focus', () => field.select());
        });

        fields[0].parentElement.addEventListener('paste', (e) => {
            const text = e.clipboardData.getData('text');
            const digits = text.replace(/\D/g, '').slice(0, fields.length);

            if (!digits) return;

            digits.split('').forEach((d, i) => {
                fields[i].value = d;
            });

            const next = fields[digits.length] || fields.at(-1);
            next.focus();

            e.preventDefault();
        });
    }
};

window.EmailHelper = {
    isValid(email) {
        if (!email) return true;
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    }
};

window.DateHelper = {
    formatDate(dateStr) {
        if (!dateStr) return '—';
        const d = new Date(dateStr);
        return d.toLocaleDateString('en-GB', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    },

    formatLocalDateFromIso(isoDateStr) {
        if (!isoDateStr || typeof isoDateStr !== 'string') {
            return '';
        }
        const trimmed = isoDateStr.trim();
        const parts = trimmed.split('-');
        if (parts.length === 3 && /^\d{4}$/.test(parts[0])) {
            const y = parseInt(parts[0], 10);
            const m = parseInt(parts[1], 10) - 1;
            const day = parseInt(parts[2], 10);
            if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(day)) {
                const d = new Date(y, m, day);
                if (!Number.isNaN(d.getTime())) {
                    return d.toLocaleDateString(undefined, {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    });
                }
            }
        }
        const fallback = new Date(trimmed);
        if (Number.isNaN(fallback.getTime())) {
            return trimmed;
        }
        return fallback.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    }
};

window.escapeHtml = function (text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
};

window.PasswordHelper = {
    checkRequirements(password) {
        const p = password || '';
        const lengthValid = p.length >= 8;
        const uppercaseValid = /[A-Z]/.test(p);
        const symbolValid = /[^A-Za-z0-9]/.test(p);
        return {
            lengthValid,
            uppercaseValid,
            symbolValid,
            get valid() {
                return this.lengthValid && this.uppercaseValid && this.symbolValid;
            }
        };
    },
    updateRuleIcon(ruleElement, isValid) {
        if (!ruleElement) return;
        const icon = ruleElement.querySelector('i');
        if (!icon) return;
        if (isValid) {
            icon.classList.remove('fa-circle-xmark', 'text-danger');
            icon.classList.add('fa-circle-check', 'text-success');
        } else {
            icon.classList.remove('fa-circle-check', 'text-success');
            icon.classList.add('fa-circle-xmark', 'text-danger');
        }
    },
    applyRuleIcons(ruleIds, req) {
        const idToKey = { 0: 'lengthValid', 1: 'uppercaseValid', 2: 'symbolValid' };
        ruleIds.forEach((id, index) => {
            const el = document.getElementById(id);
            if (el) this.updateRuleIcon(el, req[idToKey[index]]);
        });
    }
};